import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ImageModeSelector.css';

const ImageModeSelector = () => {
  const navigate = useNavigate();

  const handle2DWorkflow = () => {
    navigate('/image-2d');
  };

  const handle3DPipeline = () => {
    navigate('/image-3d-edit');
  };

  return (
    <section className="mode-wrapper">
      <div className="mode-card">
        <header className="mode-header">
          <span className="mode-eyebrow">Select image workflow</span>
          <h1>How would you like to process this image?</h1>
          <p>
            Choose between a simple 2D engraving-ready export and the full 3D pipeline used for crystal engraving
            previews.
          </p>
        </header>

        <div className="mode-grid">
          <button
            type="button"
            className="mode-option"
            onClick={handle2DWorkflow}
          >
            <div className="mode-option-header">
              <span className="mode-option-label">2D image → Engraving-ready PNG</span>
              <span className="mode-tag mode-tag--primary">Guided</span>
            </div>
            <p className="mode-option-description">
              Prepare high-contrast grayscale output that is ready for laser or crystal engraving workflows.
            </p>
          </button>

          <button
            type="button"
            className="mode-option"
            onClick={handle3DPipeline}
          >
            <div className="mode-option-header">
              <span className="mode-option-label">2D image → 3D crystal pipeline</span>
              <span className="mode-tag mode-tag--primary">Active</span>
            </div>
            <p className="mode-option-description">
              Produce 3D Assets and Previews for 3D Crystal Engraving.
            </p>
          </button>
        </div>

        <p className="mode-footnote">
          You can switch workflows later from the navigation without affecting your account or existing jobs.
        </p>
      </div>
    </section>
  );
};

export default ImageModeSelector;
